import React from "react";
import { MessageSquare, MoreHorizontal, Archive } from "lucide-react";
import UnifiedHeader from "@/components/layout/UnifiedHeader";
import { useCurrentNavItem } from "@/hooks/useCurrentNavItem";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

interface ChatsHeaderProps {
  showDeletedChats?: boolean;
  onToggleDeletedChats?: () => void;
}

export const ChatsHeader: React.FC<ChatsHeaderProps> = ({ 
  showDeletedChats = false,
  onToggleDeletedChats 
}) => {
  const currentNavItem = useCurrentNavItem();
  const Icon = currentNavItem?.icon || MessageSquare;

  const rightContent = (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-8 w-8 p-0 text-white/70 hover:text-white hover:bg-white/10"
        >
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent 
        align="end" 
        className="w-56 bg-black/95 backdrop-blur-xl border border-white/10"
      >
        <DropdownMenuItem
          onClick={onToggleDeletedChats}
          className="text-white/80 hover:text-white hover:bg-white/10 focus:bg-white/10 focus:text-white cursor-pointer"
        >
          <Archive className="mr-2 h-4 w-4" />
          {showDeletedChats ? 'Ocultar conversas excluídas' : 'Mostrar conversas excluídas'}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );

  return (
    <UnifiedHeader
      title={currentNavItem?.label || "Conversas"}
      subtitle={currentNavItem?.description || "Suas conexões exclusivas"}
      icon={Icon}
      iconColor="text-white"
      iconBgColor="bg-luxury-pinkBright border-luxury-pinkBright"
      rightContent={rightContent}
    />
  );
};
